import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import SendJobForm from 'app/Components/Page/CellcomCareersPage/Shared/Utils/SendJobForm/SendJobForm';
import {setCareerScope} from 'app/Components/Page/CellcomCareersPage/Shared/Utils/Constants';
import CollapseAdButton from 'app/Components/Page/CellcomCareersPage/Shared/Utils/AdsCollapse/CollapseAdButton';
import Config from 'app/Config';
import LocationJobIcon from '../Img/LocationJob.svg';
import ScopeJobIcon from '../Img/ScopeJob.svg';
import UtilsCareersIcon from '../Img/UtilsCareers.svg';
import HotJobIcon from '../Img/HotJob.svg';

const CareersAdItem = ({context, jobAd, handleChangeCollapse, setSubmitData, gtag4, cities}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [jobAds, setJobAds] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    function reportWindowSize() {
      setIsMobile(window.innerWidth < 767);
    }

    window.addEventListener('resize', reportWindowSize);

    return () => window.removeEventListener('resize', reportWindowSize);
  }, []);
  const handleSendJobOnWhatsapp = () => {
    if (jobAd?.whatsappNumber && jobAd?.whatsappNumber?.length > 0) {
      window.open(`https://api.whatsapp.com/send?phone=${jobAd.whatsappNumber}`, '_blank');
    }
  };

  useEffect(() => {
    setJobAds(jobAd);
  }, [jobAd]);

  return (
    <div key={jobAd.codeJob} className='careers-adItem'>
      <div className='careers-adItem__header'>
        <span className='careers-adItem__logo'>
          <Image src={Config.epiBaseUrl + jobAd?.logoIcon?.url} alt='Logo' />
        </span>
        <span> {!isMobile && <span className={'careers-adItem__lineHeader'} />}</span>
        {!isMobile ? <label className='careers-adItem__label'>{jobAd?.title}</label> : <label className='careers-adItem__label'></label>}
        {jobAd.isHotAd ? (
          <span className='careers-adItem__hotJob'>
            <Image src={HotJobIcon} alt='Hot Job Icon' />
            <span>משרה חמה</span>
          </span>
        ) : (
          <></>
        )}
      </div>
      {isMobile && (
        <>
          <div className='careers-adItem__label'>{jobAd?.title}</div>
        </>
      )}
      <div className='careers-adItem__details'>
        <Image src={UtilsCareersIcon} alt='Utils Careers Icon' />
        <span style={{fontWeight: isMultiply(jobAd.listAdLocation, jobAd.careerScope) ? 700 : 500, fontFamily: '$ragSansSemiBold'}}>
          {jobAd.utilJobs}
        </span>
        <span>
          {jobAd.listAdLocation.length > 1 ? (
            <>
              <br />
              <Image src={LocationJobIcon} alt='Location Icon' />
              <span style={{color: '#4a4a4a', fontWeight: 700, fontFamily: '$ragSansSemiBold'}}>אזור</span>
              {jobAd.listAdLocation.map((location, index) => (
                <React.Fragment key={index}>
                  <span>{location}</span>
                  {index < jobAd.listAdLocation.length - 1 && <span className={'careers-adItem__line'} />}
                </React.Fragment>
              ))}
            </>
          ) : (
            <>
              <Image src={LocationJobIcon} alt='Location Icon' />
              <span>{jobAd.listAdLocation[0]}</span>
            </>
          )}
        </span>
        {jobAd.careerScope.length > 1 ? (
          <>
            <br />
            <Image src={ScopeJobIcon} alt='Scope Job Icon' />
            <span style={{color: '#4a4a4a', fontWeight: 700, fontFamily: '$ragSansSemiBold'}}>היקף משרה</span>
            {jobAd.careerScope.map((scope, index) => (
              <React.Fragment key={index}>
                <span>{setCareerScope[scope]}</span>
                {index < jobAd.careerScope.length - 1 && <span className='careers-adItem__line' />}
              </React.Fragment>
            ))}
          </>
        ) : (
          <>
            <Image src={ScopeJobIcon} alt='Scope Job Icon' />
            <span>{setCareerScope[jobAd.careerScope[0]]}</span>
          </>
        )}
      </div>
      <div className='careers-adItem__collapse'>
        <CollapseAdButton
          cardTitle={'לתיאור המשרה המלא'}
          setIsOpen={handleChangeCollapse}
          isOpen={jobAd.checked}
          jobCode={jobAd.codeJob}
          jobLocation={jobAd.listAdLocation}
        />
      </div>
      {jobAd.checked && (
        <>
          {isMobile && <span className={'careers-adItem__horizontal'} />}
          <div className='careers-adItem__open-collapse'>
            <div className='careers-adItem__open-collapse__column__info'>
              <div className='careers-adItem__open-collapse__details'>
                <label className='careers-adItem__open-collapse__title'>תיאור משרה</label>
                <div className='' dangerouslySetInnerHTML={{__html: jobAd.description}} />

              </div>
              {/*<span>{jobAd.description}</span>*/}
              <div className='careers-adItem__open-collapse__details'>
                <label className='careers-adItem__open-collapse__title'>דרישות התפקיד</label>
                <ul>
                  {jobAd?.requirements?.length > 0 &&
                    jobAd.requirements.map((requirement, index) => (
                      <li key={index}>
                        <span>{requirement}</span>
                      </li>
                    ))}
                </ul>
              </div>

              {jobAd?.bottomText && <div className='careers-adItem__bottomText' dangerouslySetInnerHTML={{__html: jobAd?.bottomText}} />}
            </div>
            <div className='careers-adItem__open-collapse__column__form'>
              <SendJobForm
                whatsapp={jobAd.whatsappNumber}
                emailJob={jobAd.email}
                codeJob={jobAd.codeJob}
                sendJobOnWhatsapp={handleSendJobOnWhatsapp}
                isResumeRequired={jobAd.isResumeRequired}
                setSubmitData={setSubmitData}
                title={jobAd?.title}
                gtag4={gtag4}
                utilJobs={jobAd.utilJobs}
                listAdLocation={jobAd.listAdLocation}
                cities={cities}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default CareersAdItem;

const isMultiply = (scope, location) => {
  if (scope.length > 1) return true;
  if (location.length > 1) return true;

  return false;
};
